<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="vendas.content"
      class="mt-5"
      :loading="loading"
      :server-items-length="vendas.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhuma venda encontrada"
      loading-text="Carregando vendas..."
      :options="optionsList"
    >
      <template v-slot:item.id="{ item }">
        {{ id(item) }}
      </template>
      <template v-slot:item.nome="{ item }">
        <px-situacao-compra-icon :situacao="item.situacao"/>
        {{ item.nome }}
      </template>
      <template v-slot:item.dataCompra="{ item }">
        {{item.dataCompra | date}}
      </template>
      <template v-slot:item.quantidadeProdutos="{ item }">
        <span v-if="!isCotacaoConjunta(item)">
          {{ item.quantidadeProdutos }} produto(s)
        </span>
        <span v-else>
          -
        </span>
      </template>
      <template v-slot:item.total="{ item }">
        <div v-if="!isCotacaoConjunta(item)">
          {{ item.total | currency(simboloMoedaFn(item.moeda),
          2,
          configuracaoFormatacaoMoedaFn(item.moeda)) }}
          <px-moeda-chip v-if="isMoedaEstrangeiraFn(item.moeda)" :moeda="item.moeda"/>
          <div class="caption" v-if="isMoedaEstrangeiraFn(item.moeda)">
            {{ item.totalConvertido | currency }}
          </div>
        </div>
        <span v-else>
          -
        </span>
      </template>
      <template v-slot:item.options="{ item }">
        <v-btn icon link :to="link(item)">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
        <px-avaliacao-dialog v-if="!item.avaliacao"
                             :compra-id="item.compraId"
                             :disabled="isDisabledAvaliacao(item)"
                             :name="item.nome"
                             title="Avaliação de venda"
                             text="Como você avalia a venda para a empresa"
                             tipo-avaliacao="COMPRADOR"
                             @update="emitUpdate"/>
        <px-show-avaliacao-menu v-if="item.avaliacao"
                                title="Avaliação da venda"
                                :avaliacao="item.avaliacao"/>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { OrigemCompra, SituacaoCompra } from 'px-business-components';
import moedaMixin from '@/mixins/moeda-mixin';

export default {
  mixins: [moedaMixin],
  props: {
    vendas: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Código',
          value: 'id',
          sortable: false,
        },
        {
          text: 'Cliente',
          value: 'nome',
        },
        {
          text: 'Data da compra',
          value: 'dataCompra',
        },
        {
          text: 'Quantidade de itens',
          value: 'quantidadeProdutos',
        },
        {
          text: 'Total',
          value: 'total',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {
    isCotacaoConjunta() {
      return (item) => item.origemCompra === OrigemCompra.keys.COTACAO_CONJUNTA.key;
    },
    isFinalizada() {
      return (item) => SituacaoCompra.keys.APROVADA.key === item.situacao;
    },
    isDisabledAvaliacao() {
      return (item) => !this.isFinalizada(item) || !item.processoAprovacao
        || this.isCotacaoConjunta(item);
    },
    link() {
      return (item) => {
        if (this.isCotacaoConjunta(item)) {
          return `venda-conjunta/${item.compraConjuntaId}`;
        }
        return `venda/${item.compraId}`;
      };
    },
    id() {
      return (item) => {
        if (this.isCotacaoConjunta(item)) {
          return item.compraConjuntaId;
        }
        return item.compraId;
      };
    },
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    emitUpdate() {
      this.$emit('update');
    },
  },
};
</script>
